// @spec IAM-STR-011
// @spec IAM-STR-036
// @spec SHL-STR-005
'use client';

import { Outlet, createFileRoute } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/security')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.security'),
  }),
  component: SecurityRouteLayout,
});

function SecurityRouteLayout() {
  return <Outlet />;
}
